import { TRACKERS } from "@/constants/Trackers";
import { FamilyMemberHistory } from "@/features/Patient/MedicalRecords/FamilyMemberHistory/FamilyMemberHistory";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/family-history")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_FAMILY_HISTORY);
  },
});

function RouteComponent() {
  return <FamilyMemberHistory />;
}
